import React, { FormEvent, useEffect, useMemo, useState } from "react";
import axios from "axios";
import EmailGeneral from "./Unibox/whatsappEmail/EmailGeneral";
import { GlobalStyles } from "@mui/material";

const ACCESS_KEY_STORAGE = "unibox_access_key";

function App() {
  const [accessKey, setAccessKey] = useState(
    () => sessionStorage.getItem(ACCESS_KEY_STORAGE) || ""
  );
  const [inputKey, setInputKey] = useState("");
  const [error, setError] = useState("");

  const isAuthenticated = useMemo(() => Boolean(accessKey.trim()), [accessKey]);

  useEffect(() => {
    if (!isAuthenticated) {
      delete axios.defaults.headers.common["x-unibox-access-key"];
      return;
    }

    axios.defaults.headers.common["x-unibox-access-key"] = accessKey;

    const nativeFetch = window.fetch.bind(window);
    window.fetch = async (input, init = {}) => {
      const nextHeaders = new Headers(init.headers || {});
      nextHeaders.set("x-unibox-access-key", accessKey);
      return nativeFetch(input, { ...init, headers: nextHeaders });
    };

    return () => {
      window.fetch = nativeFetch;
    };
  }, [accessKey, isAuthenticated]);

  const onLogin = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const normalized = inputKey.trim();
    if (!normalized) {
      setError("Introduce la clave de acceso.");
      return;
    }
    sessionStorage.setItem(ACCESS_KEY_STORAGE, normalized);
    setAccessKey(normalized);
    setError("");
    setInputKey("");
  };

  const onLogout = () => {
    sessionStorage.removeItem(ACCESS_KEY_STORAGE);
    setAccessKey("");
    setInputKey("");
    setError("");
  };

  return (
    <>
      <GlobalStyles
        styles={{
          ".ProseMirror-selectednode": {
            outline: "none !important",
            boxShadow: "none !important",
          },
          ".ProseMirror-node-selected": {
            outline: "none !important",
            boxShadow: "none !important",
          },
          ".ProseMirror .selectedNode": {
            outline: "none !important",
            boxShadow: "none !important",
          },
          ".ProseMirror *[style*='outline']": {
            outline: "none !important",
          },
          ".ProseMirror *[style*='border']": {
            border: "none !important",
          },
          ".ProseMirror *[style*='box-shadow']": {
            boxShadow: "none !important",
          },

          // 🔥 IMPORTANTE: quita el borde del editor entero
          ".ProseMirror": {
            outline: "none !important",
            border: "none !important",
            minHeight: "200px",
            padding: "10px",
          },
          ".ProseMirror:focus": {
            outline: "none !important",
            border: "none !important",
          },
          ".ProseMirror:focus-visible": {
            outline: "none !important",
          },
          /* ".ProseMirror p": {
            marginTop: "4px !important",
            marginBottom: "4px !important",
          }, */
          // opcional para aún menos espacio
          ".ProseMirror p + p": {
            marginTop: "2px !important",
            marginBottom: "2px !important",
          },

          ".ProseMirror p": {
            margin: "0 0 8px",
          },
        }}
      />

      {!isAuthenticated ? (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#f4f6fb",
            fontFamily: "Inter, Arial, sans-serif",
          }}
        >
          <form
            onSubmit={onLogin}
            style={{
              width: "100%",
              maxWidth: 420,
              background: "#fff",
              border: "1px solid #dde3ef",
              borderRadius: 12,
              padding: 24,
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
            }}
          >
            <h2 style={{ margin: "0 0 8px 0" }}>Acceso restringido</h2>
            <p style={{ margin: "0 0 16px 0", color: "#4b5563" }}>
              Introduce la clave de seguridad para abrir UNIBOX.
            </p>
            <input
              type="password"
              value={inputKey}
              onChange={(e) => setInputKey(e.target.value)}
              placeholder="Clave de acceso"
              autoFocus
              style={{
                width: "100%",
                boxSizing: "border-box",
                borderRadius: 8,
                border: "1px solid #cfd6e4",
                padding: "10px 12px",
                marginBottom: 12,
              }}
            />
            {error ? (
              <div style={{ color: "#b42318", marginBottom: 12 }}>{error}</div>
            ) : null}
            <button
              type="submit"
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: 8,
                border: "none",
                background: "#1d4ed8",
                color: "#fff",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Entrar
            </button>
          </form>
        </div>
      ) : (
        <div style={{ height: "100vh", width: "100%", overflow: "hidden" }}>
          <button
            onClick={onLogout}
            style={{
              position: "fixed",
              top: 12,
              right: 12,
              zIndex: 9999,
              padding: "6px 10px",
              borderRadius: 8,
              border: "1px solid #d1d5db",
              background: "#fff",
              cursor: "pointer",
            }}
          >
            Cerrar sesion
          </button>
          {/*  <EmailViewerPro /> */}
          <EmailGeneral />
        </div>
      )}
    </>
  );
}

export default App;
